import { useEffect, useState } from "react"
import { Modal } from "react-bootstrap"
import close from "../../../assets/images/close.svg"
import { useAuth } from "../../../context/auth-user"

export function AddDocumentsModal({ show, onHide, availableDocs, isLoadingAvailable, isDocAssigned, onConfirm, isAssigning, selectedEntityId }) {
    const { user } = useAuth()
    const userLogged = user?.selectedProfile
    const darkLightMode = userLogged?.darkLightMode
    const [pendingIds, setPendingIds] = useState(new Set())

    useEffect(() => {
        setPendingIds(new Set())
    }, [selectedEntityId, show])

    const togglePending = (docId) => {
        if (isAssigning || isDocAssigned(docId)) return
        setPendingIds(prev => {
            const next = new Set(prev)
            if (next.has(docId)) next.delete(docId)
            else next.add(docId)
            return next
        })
    }

    const handleConfirm = () => {
        const docsToAdd = availableDocs.filter(d => pendingIds.has(d._id))
        if (docsToAdd.length > 0) onConfirm(docsToAdd)
        setPendingIds(new Set())
        onHide()
    }

    const handleClose = () => {
        setPendingIds(new Set())
        onHide()
    }

    return (
        <Modal
            show={show}
            onHide={handleClose}
            size="xl"
            centered
            className={`addDocumentsModal ${darkLightMode ? "darkMode" : ""}`}
        >
            <Modal.Body>
                <img className="closeModal" src={close} onClick={handleClose} alt="Cattenna Platform" />
                <h3 className="modalTitle">Select documents</h3>

                <div className="docsListWrapper">
                    {isLoadingAvailable ? (
                        <p className="loadingText">Loading...</p>
                    ) : (
                        <>
                            {/* Desktop table */}
                            <div className="d-none d-lg-block">
                                <div className="docsTableTitles">
                                    <div className="docCol checkDocCol"><span className="label">Document</span></div>
                                    <div className="docCol countryCol"><span className="label">Country</span></div>
                                    <div className="docCol typeCol"><span className="label">Type of person</span></div>
                                </div>

                                {availableDocs.map((doc) => {
                                    const assigned = isDocAssigned(doc._id)
                                    const isDisabled = assigned || isAssigning
                                    const checked = assigned || pendingIds.has(doc._id)
                                    return (
                                        <div
                                            key={doc._id}
                                            className={`docsTableRow${assigned ? " assigned" : ""}`}
                                            onClick={() => togglePending(doc._id)}
                                        >
                                            <div className="docCol checkDocCol">
                                                <input
                                                    type="checkbox"
                                                    checked={checked}
                                                    disabled={isDisabled}
                                                    onChange={() => togglePending(doc._id)}
                                                    onClick={(e) => e.stopPropagation()}
                                                />
                                                <span style={{ cursor: isDisabled ? "not-allowed" : "pointer" }}>
                                                    {doc.documentName}
                                                </span>
                                            </div>
                                            <div className="docCol countryCol">{doc.country ?? "—"}</div>
                                            <div className="docCol typeCol">{doc.typePerson ?? "—"}</div>
                                        </div>
                                    )
                                })}
                            </div>

                            {/* Mobile list */}
                            <div className="d-lg-none addDocsMobileList">
                                {availableDocs.map((doc) => {
                                    const assigned = isDocAssigned(doc._id)
                                    const isDisabled = assigned || isAssigning
                                    const checked = assigned || pendingIds.has(doc._id)
                                    return (
                                        <div
                                            key={doc._id}
                                            className={`addDocsMobileRow${assigned ? " assigned" : ""}`}
                                            onClick={() => togglePending(doc._id)}
                                        >
                                            <div className="addDocsMobileHeader">
                                                <input
                                                    type="checkbox"
                                                    checked={checked}
                                                    disabled={isDisabled}
                                                    onChange={() => togglePending(doc._id)}
                                                    onClick={(e) => e.stopPropagation()}
                                                />
                                                <span
                                                    className="addDocsMobileName"
                                                    style={{ cursor: isDisabled ? "not-allowed" : "pointer" }}
                                                >
                                                    {doc.documentName}
                                                </span>
                                            </div>
                                            <div className="addDocsMobileInfo">
                                                <div className="addDocsMobileInfoItem">
                                                    <span className="addDocsMobileValue">{doc.country ?? "—"}</span>
                                                    <span className="addDocsMobileLabel">Country</span>
                                                </div>
                                                <div className="addDocsMobileInfoItem">
                                                    <span className="addDocsMobileValue">{doc.typePerson ?? "—"}</span>
                                                    <span className="addDocsMobileLabel">Type of person</span>
                                                </div>
                                            </div>
                                        </div>
                                    )
                                })}
                            </div>
                        </>
                    )}
                </div>

                <div className="actions">
                    <button className="btnBgWhiteTextBlack" onClick={handleClose}>Cancel</button>
                    <button
                        className="btnBgBlueTextGradient"
                        disabled={isAssigning || pendingIds.size === 0}
                        onClick={handleConfirm}
                    >
                        {isAssigning ? "Saving..." : "Add documents"}
                    </button>
                </div>
            </Modal.Body>
        </Modal>
    )
}


